import { FlexWrapper } from 'Shared/FlexWrapper';
import React from 'react';
import styles from './user-avatar.module.css';

interface UserAvatarProps {
    firstName: string;
    lastName: string;
}

function UserAvatar({ firstName, lastName }: UserAvatarProps): React.ReactElement<UserAvatarProps> {
    return (
        <FlexWrapper align="center" justify="center" className={styles.UserAvatar} data-qa="user-avatar">
            <p>{`${firstName?.[0]?.toUpperCase()}${lastName?.[0]?.toUpperCase()}`}</p>
        </FlexWrapper>
    );
}

export default UserAvatar;
